// @flow
import PropTypes from 'prop-types';
import templateConst from 'app/common/lib/templateConst';
import type { FacebookUserData } from 'app/packages/pinterest-flow-types/authentication';
import type {
  SignupCredentialsAndLoggingData,
  SignupOptions,
} from 'app/packages/pinterest-flow-types/registration';

export const SIGNUP_METHOD = {
  FACEBOOK: 'facebook',
  GOOGLE_ONE_TAP: 'google_one_tap',
  GOOGLE: 'google',
  EMAIL: 'email',
  OTHER: 'other',
};

export type SignupMethodType = $Values<typeof SIGNUP_METHOD>;

export const getSignupMethod = (signupOptions: { ...SignupOptions }) => {
  if (signupOptions.facebook_id) {
    return SIGNUP_METHOD.FACEBOOK;
  } else if (signupOptions.google_open_id_token) {
    return SIGNUP_METHOD.GOOGLE_ONE_TAP;
  } else if (signupOptions.gplus_code || signupOptions.gplus_id_token) {
    return SIGNUP_METHOD.GOOGLE;
  } else if (signupOptions.email) {
    return SIGNUP_METHOD.EMAIL;
  }

  return SIGNUP_METHOD.OTHER; // other should never happen
};

export const RegistrationCredentialsPropType = PropTypes.shape({
  credentials: PropTypes.shape({}),
  userData: PropTypes.shape({}),
  type: PropTypes.oneOf(Object.values(SIGNUP_METHOD)),
});

// @todo (sophia/javery) This should be renamed to SocialRegistrationCredentialsType, since it's being used
// for all registration credential types
export type FBRegistrationCredentialsType = {
  credentialsAndLoggingData: SignupCredentialsAndLoggingData,
  userData: FacebookUserData,
  type: SignupMethodType,
};

export type GenericAuthenticationCredsType = {
  credentialsAndLoggingData: SignupCredentialsAndLoggingData,
  userData: $Shape<FacebookUserData>,
  type: SignupMethodType,
};

export const registrationRequiresAgeGDPR = (country: string) =>
  country in templateConst.settings.MINIMUM_AGE_BY_EU_COUNTRY;

export const registrationRequiresAgeEN = (country: string) =>
  templateConst.settings.EN_COUNTRIES_WITH_MANDATORY_AGE.includes(country);

export default undefined;
